module.exports = "<div class=\"password-change row\"> <dv-benutzerprofil-view benutzer=\"vm.benutzerToEdit\" force-password-change=\"true\" no-email-entry=\"true\" phone-required=\"true\"> </dv-benutzerprofil-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/component/invitedUserProfileView/invitedUserProfileView.html
// module id = uemi
// module chunks = 0